if (!window.__productSpotlightTiltInit) {
  window.__productSpotlightTiltInit = true;

  const MAX_TILT_DEG = 10;

  const setupTilt = (stage) => {
    const target = stage.querySelector('[data-spotlight-tilt]');
    if (!target) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    stage.addEventListener('mousemove', (event) => {
      const rect = stage.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      const rotateY = x * MAX_TILT_DEG * 2;
      const rotateX = y * -1 * MAX_TILT_DEG * 2;
      target.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    });

    stage.addEventListener('mouseleave', () => {
      target.style.transform = 'rotateX(0deg) rotateY(0deg)';
    });
  };

  document.querySelectorAll('[data-spotlight-stage]').forEach(setupTilt);
}
